import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_APPARATO_SPLITTER } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDApparatoSplitterState extends EntityState<IID_APPARATO_SPLITTER, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_APPARATO_SPLITTER , realtimeEntity: 'IID_ApparatoSplitter'})
@InterfaceDataStore(InterfaceName.APPARATO_SPLITTER)
export class IIDApparatoSplitterStore extends EntityStore<IIDApparatoSplitterState> {
  constructor() {
    super([]);
  }
}
